import React from 'react';
import {
  AppButton,
  AppCol,
  AppForm,
  AppFormLabel,
  AppRow,
  AppSelect,
  AppSpace,
  AppTextField,
} from '@/components/atoms';
import { CollapsibleCard } from '@/components/molecules';
import type { InsurerAttentionSearchFilters, Prefecture } from '../types';

interface Props {
  filters: InsurerAttentionSearchFilters;
  prefectures: Prefecture[];
  searching: boolean;
  isSearchChanged: boolean;
  onFilterChange: (name: keyof InsurerAttentionSearchFilters, value: string | number) => void;
  onSubmit: () => void;
}

export const InsurerAttentionSearchForm: React.FC<Props> = ({
  filters,
  prefectures,
  searching,
  isSearchChanged,
  onFilterChange,
  onSubmit,
}) => (
  <CollapsibleCard title="県別注意事項">
    <AppForm layout="vertical" onFinish={onSubmit}>
      <AppRow gutter={[24, 24]}>
        <AppCol xs={24} sm={12} lg={6}>
          <AppSpace orientation="vertical" className="w-full">
            <AppFormLabel label="保険者番号" />
            <AppTextField
              name="insurer_number"
              value={filters.insurer_number}
              onChange={e => onFilterChange('insurer_number', e.target.value)}
              onPressEnter={onSubmit}
              placeholder="入力してください"
              data-skip-enter-nav
            />
          </AppSpace>
        </AppCol>
        <AppCol xs={24} sm={12} lg={6}>
          <AppSpace orientation="vertical" className="w-full">
            <AppFormLabel label="都道府県情報" />
            <AppSelect
              className="w-full"
              value={filters.prefecture_id || undefined}
              onChange={value => onFilterChange('prefecture_id', String(value ?? ''))}
              options={[
                { label: '', value: '' },
                ...prefectures.map(pref => ({ label: pref.name, value: String(pref.id) })),
              ]}
            />
          </AppSpace>
        </AppCol>
        <AppCol xs={24} sm={12} lg={6}>
          <AppSpace orientation="vertical" className="w-full">
            <AppFormLabel label="保険者名称" />
            <AppTextField
              name="insurer_name"
              value={filters.insurer_name}
              onChange={e => onFilterChange('insurer_name', e.target.value)}
              onPressEnter={onSubmit}
              placeholder="入力してください"
              data-skip-enter-nav
            />
          </AppSpace>
        </AppCol>
        <AppCol xs={24} sm={12} lg={6}>
          <AppSpace orientation="vertical" className="w-full">
            <AppFormLabel label="保険者名カナ" />
            <AppTextField
              name="insurer_name_kana"
              value={filters.insurer_name_kana}
              onChange={e => onFilterChange('insurer_name_kana', e.target.value)}
              onPressEnter={onSubmit}
              placeholder="入力してください"
              data-skip-enter-nav
            />
          </AppSpace>
        </AppCol>
      </AppRow>

      <AppRow className="justify-center mt-6">
        <AppButton
          type="primary"
          loading={searching}
          disabled={!isSearchChanged}
          icon={<i className="fa fa-search" />}
          htmlType="submit"
          className="w-fit"
        >
          {searching ? '検索中...' : '検索'}
        </AppButton>
      </AppRow>
    </AppForm>
  </CollapsibleCard>
);
